<template>
	<v-btn
		type="button"
		class="app-btn ml-2"
		:class="{ blue: blue, red: red, green: green, gray: gray }"
		:style="style"
		v-bind="$attrs"
		v-on="$listeners">
		{{ text }}
	</v-btn>
</template>
<script>
function style() {
	return `width: ${this.width}px; height: ${this.height}px`;
}

export default {
	name: 'app-button',
	inheritAttrs: false,
	computed: {
		style,
	},
	props: {
		text: {
			type: String,
			default: 'Aceptar',
		},
		isLoading: {
			type: Boolean,
			default: false,
		},
		blue: {
			type: Boolean,
			default: false,
		},
		red: {
			type: Boolean,
			default: false,
		},
		green: {
			type: Boolean,
			default: false,
		},
		gray: {
			type: Boolean,
			default: false,
		},
		width: {
			type: [Number, String],
		},
		height: {
			type: [Number, String],
			default: '35',
		},
	},
};
</script>
<style lang="scss" scoped>
.app-btn {
	border-radius: 5px !important;
	box-shadow: none !important;
	color: map-get($colors, white) !important;
	font-family: map-get($fonts, open-semibold);
	font-size: map-get($sizes, small);
	margin: 0px;
	text-transform: none !important;
	width: 100%;

	&.blue {
		background: map-get($colors, secondary) !important;
	}

	&.red {
		background: rgb(255, 0, 43) !important;
		color: map-get($colors, white) !important;
	}

	&.green {
		background: map-get($colors, btn-green) !important;
	}

	&.gray {
		background: #02979b !important;
		color:white !important;
	}
}
</style>


// WEBPACK FOOTER //
// src/components/shared/app-button.vue